import { connect } from 'react-redux';
import LaporanInvoiceDetail from '../../../../views/Finance/Spp/LaporanKeu/LaporanInvoiceDetail.laporaninvoice.view';
import { getAdjustmentJournal } from '../../../../states/thunks/finance.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetAdjustmentJournal: payload => dispatch(getAdjustmentJournal(payload)),
  };
}

export default connect(null, mapDispatchToProps)(LaporanInvoiceDetail);
